import { b } from "@/b";
import { FragmentData } from "@gqlb/core";
import { VIP_SUBSCRIPTION_SLUG } from "./constants";
import { useApolloClient, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";

export const Hook_IsSubscribedToVIP_Fragment = b.fragment(
  "Hook_IsSubscribedToVIP",
  "Query",
  (b) => [
    //
    b.viewer((b) => [
      b.id(),
      b.account((b) => [
        b.id(),

        b
          .subscription({ slug: VIP_SUBSCRIPTION_SLUG }, (b) => [
            //
            b.subscription((b) => [b.id()]),
            b.active(),
          ])
          .alias("vipSubscription"),
      ]),
      b.cart((b) => [
        b.items((b) => [
          b.id(),
          b.__on("CartItemSubscription", (b) => [
            b.id(),
            b.subscription((b) => [b.id(), b.slug()]),
          ]),
        ]),
      ]),
    ]),
  ]
);

export function useIsSubscribedToVIP(
  data: FragmentData<typeof Hook_IsSubscribedToVIP_Fragment>,
  includeCart: boolean
) {
  if (
    includeCart &&
    data.viewer.cart.items.some((i) => {
      if (i.__typename !== "CartItemSubscription") {
        return false;
      }
      return i.subscription.slug === VIP_SUBSCRIPTION_SLUG;
    })
  ) {
    return true;
  }

  return data.viewer.account?.vipSubscription?.active ?? false;
}

const ManageSubscription_Query = b.query("ManageSubscription", (b) => [
  b.viewer((b) => [
    b.id(),
    b.account((b) => [b.id(), b.stripeCustomerPortalUrl()]),
  ]),
]);

export function useGetManageSubscriptionUrl() {
  const client = useApolloClient();
  return async () => {
    const { data } = await client.query({
      fetchPolicy: "no-cache",
      query: ManageSubscription_Query.document(),
    });
    return data?.viewer.account?.stripeCustomerPortalUrl;
  };
}

export function useDeferredLoad(afterLoadMs: number) {
  const [load, setLoad] = useState(false);
  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;
    const handleLoad = () => {
      timer = setTimeout(() => {
        setLoad(true);
      }, afterLoadMs);
    };

    window.addEventListener("load", handleLoad);
    return () => {
      window.removeEventListener("load", handleLoad);
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [afterLoadMs]);
  return load;
}
